import { cameraScheduleSchema } from '@sophocles/entities/CameraSchedule';
import { List, Record } from 'immutable';
import { schema } from 'normalizr';

export const Camera = new Record({
  id: undefined,
  cic: undefined,
  camera_number: undefined,
  mirrored_vertically: undefined,
  mirrored_horizontally: undefined,
  is_rotated: undefined,
  rotation_amount: undefined,
  description: undefined,
  motion_alarm_enabled: undefined,
  pointing_at_relay_load: undefined,
  schedules: List(),
  images: List(),
});

export const cameraSchema = new schema.Entity('cameras', {
  schedules: [cameraScheduleSchema],
});
